/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkFlowIdQueryOperator");
    }

    getFixupPrototypeFunction() { return WorkFlowIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowIdQueryOperator>): WorkFlowIdQueryOperator {
        let obj = Object.assign(new WorkFlowIdQueryOperator(), model);
        WorkFlowIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowIdQueryOperator>): WorkFlowIdQueryOperator {
        if (!model) return null;
        return WorkFlowIdQueryOperator.newInstance(<WorkFlowIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowIdQueryOperator) {
        if (!obj) return;

        models.WorkFlowIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkFlowIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the workflow
     */
    workflow_ids: Array<string>;

}
